import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormBase } from 'src/app/_models/form-base';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-slide-toggle',
  templateUrl: './slide-toggle.component.html',
  styleUrls: ['./slide-toggle.component.scss'],
  imports: [FormsModule, ReactiveFormsModule, MatSlideToggle, MatIcon],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SlideToggleComponent {
  /** Field form base (required) */
  field = input<FormBase<boolean>>();

  /** Parent FormGroup containing the control (required) */
  parentForm = input<FormGroup>();

  /** Tooltip text for the slide toggle (optional) */
  tooltipText = input<string>();
}
